import cx from 'classnames';
import React from 'react';
import styles from './Panel.mscss';

interface OwnProps {
    className?: string;
    style?: React.CSSProperties;
    tag?: string;
    children?: React.ReactNode;
}

type Props = OwnProps;

const Panel = React.forwardRef<HTMLElement, Props>(({ className, style, children, tag = 'div' }, ref) => {
    const Tag: any = tag;

    return (
        <Tag className={cx(styles.Panel, className)} style={style} ref={ref}>
            {children}
        </Tag>
    );
});

export default Panel;
